import React from 'react';
import LogoImg from '../img/MEDEUON.png';
import './css/medeuon_icon.css';

const Logo = () => {
  return (
    <div className="med-icon">
      <img src={LogoImg} alt="Company Logo" />
    </div>
  );
};

export default Logo;